(function () {
    'use strict';

    angular
        .module('app')
        .factory('commandService', commandService);

    commandService.$inject = ['$rootScope',
        '$mdDialog',
        '$localStorage',
        'optionsService',
        'downloadService',
        '$state',
        '$q',
        'loginService',
        'gridDataService',
        'searchForChildrenService',
        '$window',
        'viewerService', '$http', 'requiredFieldsService'];

    function commandService($rootScope,
        $mdDialog,
        $localStorage,
        optionsService,
        downloadService,
        $state,
        $q,
        loginService,
        gridDataService,
        searchForChildrenService,
        $window,
        viewerService, $http, requiredFieldsService) {
        var service = {
            records: [],
            launchCommand: launchCommand,
            launchErrors: launchErrors,
            launchLocalViewer: launchLocalViewer,
            launchAdeptViewer: launchAdeptViewer,
            refreshVL: refreshVL,
            searchForChildren: searchforchildren,
            handleRequiredFields: handleRequiredFields,
            updateRequiredFields: updateRequiredFields,
            convertToPdf: convertToPdf, 
            clearItemsCache: clearItemsCache
        };

        service.controllers = {
            assign: 'assign',
            unassign: 'assign',
            approve: 'approve',
            reject: 'approve',
            rejectto: 'expediteApprove',
            expediteapprove: 'expediteApprove',
            expeditereject: 'expediteApprove',
            finalapprove: 'finalApprove',
            reroute: 'reroute',
            setdocumentworkflow: 'setDocumentWorkflow',
            restartworkflow: 'finalApprove',
            download: 'download',
            createversion: 'createVersion',
            sendto: 'sendto',
            checkout: 'checkout',
            checkin: 'checkin',
            newdoc: 'newdoc',
            releasecheckout: 'releasecheckout',
            acquirecheckout: 'acquirecheckout',
            acquirecheckoutonelib: 'acquirecheckoutonelib',
            deletedoc: 'deletedoc',
            undocheckoutofunchangedchildren: 'undocheckoutofunchangedchildren',
            copy: 'copy',
            rename: 'rename',
            selectiontree: 'selectiontree',
            refreshextracteddata: 'refreshextracteddata',
            clearextracteddata: 'clearextracteddata',
            searchforchildren: 'searchforchildren',
            copytocurrent: 'copytocurrent',
            
        }

        return service;

        function launchCommand(command) {
            $mdDialog.show({
                parent: angular.element(document.body),
                templateUrl: 'app/selectioncommand/templates/selectioncommand_' + service.controllers[command.toLowerCase()] + '.html',
                controller: service.controllers[command],
                fullscreen: false,
                multiple: true,
                locals: {
                    records: service.records,
                    command: command
                }
            });
        }

        function launchErrors(records) {
            $mdDialog.show({
                parent: angular.element(document.body),
                templateUrl: 'app/errorlist/templates/errorlist.html',
                controller: 'errorList',
                fullscreen: false,
                locals: {
                    records: records,
                }
            });
        }

        //////////////////////////////////////////////////////////////////////////
        // Viewer Code - windowless/dialogless code that needs to run


        //////////////////////////////////////////////////////////////////////////
        // Open the file with local viewer
        function launchLocalViewer() {
            var deferred = $q.defer();
            UseLocalViewer().then(function (rtn) {
                deferred.resolve(rtn);
            });
            return deferred.promise;
        }

        function UseLocalViewer() {
            var deferred = $q.defer();

            //alert("Using Local Viewer.");

            // Get the item into a selection list.
            var firstSelectedItem = service.records.list[0];
            var filename = firstSelectedItem.filename;
            var tableNumber = firstSelectedItem.tableNumber;
            var fileId = firstSelectedItem.fileId;
            var minRev = firstSelectedItem.minRev;
            var majRev = firstSelectedItem.majRev;
            var selectionItem = {
                filename: filename,
                sortval: filename,
                tableNumber: +tableNumber,
                fileId: fileId,
                majRev: +majRev,
                minRev: +minRev,
                detailedInfo: null,
                commandParams: null,
                docId: null
            };
            var items = [];
            items.push(selectionItem);
            var slx = { mode: 0, order: 0, list: items };

            // Call download.
            var options = { IncludeChildren: false, ZipFiles: false, ZipPassword: "" };
            downloadService.Download(options, slx).then(function (response) {
                // Handle download errors.
                var atLeastOneError = false;
                angular.forEach(response.data, function (item) {
                    // If there was an error, report it and exit.
                    if (item.ReturnErrorCode != 0) {
                        var errMsg = item.si.errFullErrStr;
                        //alert(errMsg);
                        var title = loginService.resourceStrings["LOCAL_VIEWER"]; // "Local Viewer"
                        var rtn = { title: title, message: errMsg, type: 2 };
                        deferred.resolve(rtn);
                    }
                    else { // Otherwise we can navigate to the file now.
                        // TD 06-25-2020 (28014) Make sure to decorate the url so the browser doesn't look to the cache for this file.
                        var fileUrl = item['FileUrl'];
                        var oDate = new Date();
                        window.open(fileUrl + '?qt=' + oDate.getTime(), "__localViewWindow__", 'resizable=1,width=1024,height=650,location=0,menubar=0');
                        return;
                    }
                });
            }, function (response) {
                // Error occurred in download
                console.log(response);
                var errMsg = response.data['Message'];
                //alert(errMsg);
                var title = loginService.resourceStrings["LOCAL_VIEWER"]; // "Local Viewer"
                var rtn = { title: title, message: errMsg, type: 3 };
                deferred.resolve(rtn);
            });

            return deferred.promise;
        }

        function clearItemsCache(records) {
            var deferred = $q.defer();
            viewerService.clearItemsCache(records).then(function() {
                deferred.resolve();
            });
            return deferred.promise;
        }

        //////////////////////////////////////////////////////////////////////////
        // Open the Adept Viewer (ADV)
        function launchAdeptViewer() {
            var deferred = $q.defer();

            // Get Viewer Options
            optionsService.getViewerOptions().then(function (viewerOptions) {
                if (viewerOptions["NewViewer"] == "true") {
                    viewerService.viewFiles(service.records.list, viewerOptions, false, gridDataService.currentFocus).then(function () {
                        deferred.resolve();
                    }, function (error) {
                        deferred.reject(error);
                    });
                }
                else {
                    OpenAutoVueWindow(firstSelectedItem, viewerOptions);
                }
            }, function (response) {
                scope.message = 'Missing viewer configuration.  Please log out, and then log in again.';
                var errorMsgId = 'VIEW_BROWSER_CONFIGURATION_MISSING';
                $mdDialog.show({
                    parent: angular.element(document.body),
                    templateUrl: 'app/selectioncommand/templates/viewError.html',
                    controller: 'viewError',
                    fullscreen: false,
                    locals: {
                        errorMsgId: errorMsgId,
                        errorMsg: ''
                    }
                });
            });

            return deferred.promise;
        }

        function convertToPdf(records, printPdf, printerName) {
            //var deferred = $q.defer();

            ////viewerService.convertToPdfServer(records[0]).then(function () {
            ////    deferred.resolve();
            ////});

            //var fileList = [];
            //angular.forEach(records, function (record) {
            //    fileList.push({ tableNumber: record.tableNumber, fileId: record.fileId, majRev: record.majRev, minRev: record.minRev });
            //});

            //viewerService.convertToPdfServer(fileList).then(function () {
            //    deferred.resolve();
            //});

            //return deferred.promise;

            var deferred = $q.defer();
            //var firstSelectedItem = service.records.list[0];

            // Get AutoVue Settings for viewing
            optionsService.getViewerOptions().then(function (viewerOptions) {
                viewerService.viewFiles(records, viewerOptions, true, gridDataService.currentFocus, printPdf).then(function () {
                    deferred.resolve();
                }, function (error) {
                    deferred.reject(error);
                });
            }, function (response) {
                scope.message = 'Missing viewer configuration.  Please log out, and then log in again.';
                var errorMsgId = 'VIEW_BROWSER_CONFIGURATION_MISSING';
                $mdDialog.show({
                    parent: angular.element(document.body),
                    templateUrl: 'app/selectioncommand/templates/viewError.html',
                    controller: 'viewError',
                    fullscreen: false,
                    locals: {
                        errorMsgId: errorMsgId,
                        errorMsg: ''
                    }
                });
            });

            return deferred.promise;


        }


        //////////////////////////////////////////////////////////////////////////
        // Save Redlines in AutoVue
        function SaveMarkups() {
            window.document.applets["JVue"].saveModifiedMarkups();
            window.document.applets["JVue"].waitForLastMethod();
        }

        // OpenAutoVueWindow
        //
        // Opens the Adept Viewer (AutoVue)
        function OpenAutoVueWindow(firstSelectedItem, viewerOptions) {
            // Build parameters to send to AutoVue Window
            var documentString = 'TableNumber=' + firstSelectedItem.tableNumber + ':';
            documentString += 'FileId=' + firstSelectedItem.fileId + ':';
            documentString += 'MinRev=' + firstSelectedItem.minRev + ':';
            documentString += 'MajRev=' + firstSelectedItem.majRev + ':';
            documentString += 'FileNE=' + encodeURIComponent(firstSelectedItem.filename) + ':';
            documentString += 'Size=' + firstSelectedItem.detailedInfo.fileSize + ':';
            documentString += 'IsParent=' + firstSelectedItem.detailedInfo.bIsParent + ':';
            documentString += 'LoginName=' + $localStorage.userInfo.id + ':';
            documentString += 'UserName=' + $localStorage.userInfo.loginName + ':';

            try {
                var fileDate = firstSelectedItem.detailedInfo.fileUtc;
                var posSpace = fileDate.indexOf(" ");
                documentString += 'Date=' + fileDate.substring(0, posSpace) + ':';
                documentString += 'Time=' + fileDate.substring(posSpace + 1).replace(":", ".").replace(":", ".") + ':';
            } catch (err) {
                console.log("Error parsing date=" + fileDate);
            }

            viewerService.canPrint(firstSelectedItem.fileId).then(function (canPrint) {
                var guiFile = canPrint ? 'AdeptConvertPrintRedline.gui' : 'viewonly.gui';
                var init_params = {
                    'EMBEDDED': 'false',
                    'VERBOSE': 'false',
                    'GUIFILE': guiFile,
                    'HEAVYWEIGHT': 'false',
                    'FILENAME': documentString,
                    'JVUESERVER': viewerOptions.jVueServer,
                    'DMS': viewerOptions.dms,
                    'USERNAME': $localStorage.userInfo.loginName,
                    'DMSARGS': 'USERNAME;DMS_PRESERVE_COOKIES;',
                    'DMS_PRESERVE_COOKIES': 'true',
                    'LOCALE': $localStorage.userInfo.currentCultureName,
                };
                console.log('language=' + $localStorage.userInfo.currentCultureName);

                viewerService.openViewer(init_params, viewerOptions.codebase).then(function () {

                }, function () {

                });
            });
        } //end OpenAutoVueWindow function

        //Bill 04-26-2018 Pass subTypeHandling=0 (engage user settings)
        function refreshVL(tableNumber, fileId, majRev, minRev, localVirtualLibraryPath) {
            var url = '../Synergis.WebApi/api/Document/GetTreeVirtualized/';
            url = url.concat(tableNumber + '/' + fileId + '/' + majRev + '/' + minRev + '/0/');
            var request = $http({
                url: url,
                method: 'PUT',
                data: JSON.stringify(localVirtualLibraryPath),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        // method performs a search
        vm.search = function (criteria) {
            // Paul.Ligowski 2017-05-08 Need to leave active to test with toolbar. // setInactive();
            fileGuideService.clearSelectedNodes();
            searchService.searchCriteria = (criteria === undefined) ? vm.criteria : criteria;
            vm.processing = true;
            gridDataService.genericDataService = searchService;
            //must identify the service in order to inject the correct one.
            gridDataService.serviceIdentifier = "searchService";
            //reset, since it's a new search
            gridDataService.totalRecords = 0;
            gridDataService.processing = true;

            //callback to be notified when the grid is done and clear the search criteria at the service level
            var callBack = function () {
                //Example on how to do callbacks
                gridDataService.unRegister(callBack);
            }

            //register the callback with the gridDataService
            gridDataService.register(callBack);
            var getType = {};
            //timeout so the overlay can be displayed and not the previous records.
            $timeout(function () {
                $state.go('layout.results.grid').then(function () {
                    if (getType.toString.call(gridDataService.reloadGrid) === '[object Function]') {
                        gridDataService.reloadGrid();
                    }
                });
            }, 0);


            //$rootScope.$broadcast('grid:reload');
        };

        //Function to handle search for children call
        function searchforchildren() {
            var vm = this;
            var getType = {};
            // method performs a search
            // NOTE: requirement for 2018 is only one item, not multiple items which is why this only takes the first item in the list
            searchForChildrenService.currentItem = service.records.list[0];
            vm.processing = true;

            //must identify the generic service in order to inject the correct one into the grid
            gridDataService.genericDataService = searchForChildrenService;
            gridDataService.serviceIdentifier = "searchForChildrenService";

            //reset, since it's a new search
            gridDataService.totalRecords = 0;
            gridDataService.processing = true;

            if (getType.toString.call(gridDataService.reloadGrid) === '[object Function]') {
                gridDataService.reloadGrid();
            }
        };


        function handleRequiredFields(slx, command) {
            var deferred = $q.defer();
            var list = slx.list;
            requiredFieldsService.checkRequiredFields(list, command).then(function (requiredFieldsData) {
                var requiredFieldFiles = {};
                var promise = $q.all([]);
                var itemsToProcess = [];
                var titleOptions = {
                    142: loginService.resourceStrings["FINAL_APPROVE"],
                    120: loginService.resourceStrings["APPROVE"],
                    128: loginService.resourceStrings["EXPEDITE_APPROVE"]
                };
                var title = titleOptions[command];

                if (requiredFieldsData == null) {
                    deferred.resolve(slx);
                    return;
                }

                angular.forEach(list, function (item, index) {
                    var fileId = item.fileId;
                    var majRev = item.majRev;
                    var minRev = item.minRev;

                    promise = promise.then(function () {
                        var d = $q.defer();

                        requiredFieldsService.processRecord(item, requiredFieldsData[fileId + majRev + minRev], title).then(function (result) {
                            if (result === "OK") {
                                //add this item to array of items to process
                                itemsToProcess.push(item);

                                
                            }
                            if (result === "CANCEL") {
                                
                            }
                            else if (result === "CANCELALL") {
                                slx.list = itemsToProcess;
                                //resolve main promise
                                deferred.resolve(slx);
                                d.reject();
                                return;
                            }

                            //OK OR CANCEL
                            d.resolve();
                            //if it's the last item, resolve the main promise.
                            if (index == list.length - 1) {
                                slx.list = itemsToProcess;
                                //resolve main
                                deferred.resolve(slx);
                            }

                        });
                        return d.promise;
                    });
                });
            }, function (error) {
                deferred.reject();
            });
            return deferred.promise;
        }

        function updateRequiredFields(list) {
            return requiredFieldsService.processQueue(list);
        }

        function getItemByKeys(arr, val) {
            for (var i = 0; i < arr.length; i++) {
                if (arr[i]['fileId'] + arr[i]['majRev'] + arr[i]['minRev'] === val)
                    return arr[i];
            }
        }

    }
})();